import { createAsyncThunk } from "@reduxjs/toolkit";
import { triggerAlert } from "redux/reducers/appSlice";
import { AuthUserCredentials, setAuthUser } from "redux/reducers/authSlice";
import { useAppDispatch } from "redux/store/hooks";
import AuthService from "services/auth";
import { SocilaSignInPayload } from "features/auth/models";
import {
  translateAPIMessage,
  translateFrontEndAlerts,
} from "utils/translation";

const useAuthUserActions = () => {
  const dispatch = useAppDispatch();
  const setAuthUserDispatch = (authUser: AuthUserCredentials) =>
    dispatch(setAuthUser(authUser));
  return {
    setAuthUserDispatch,
  };
};

export const registerUserViaEmail = createAsyncThunk(
  "register/email",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.registerUserViaEmail(data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(12001),
        })
      );
      return true;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);
export const signInUserViaEmail = createAsyncThunk(
  "signin/email",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.signinUserViaEmail(data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(12002),
        })
      );

      return {
        success: true,
        user: { ...response.data?.user, token: response.data?.token },
      };
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const signInUserViaSocial = createAsyncThunk(
  "signin/social",
  async (data: SocilaSignInPayload, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.signInSocial(data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(12002),
        })
      );

      return {
        success: true,
        user: { ...response.data?.user, token: response.data?.token },
      };
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      rejectWithValue(error);
      return rejectWithValue(error);
    }
  }
);

export const verifyEmail = createAsyncThunk(
  "verify/email",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.verifyEmail(data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(12003),
        })
      );
      return response.data?.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const submitResetPasswordEmail = createAsyncThunk(
  "password/reset/submit/email",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.submitRestPasswordEmail(data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(12004),
        })
      );
      return response.data?.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const resetPasswordEmailVerify = createAsyncThunk(
  "password/reset/verify/email",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.verifyRestPasswordEmail(data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(12005),
        })
      );
      return response.data?.user;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "password/reset",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.restPassword(data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(12006),
        })
      );
      return true;
      // return response.data?.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getAuthUserProfile = createAsyncThunk(
  "auth/user/profile/get",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await AuthService.getAuthUserProfile();

      return response.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);
export default useAuthUserActions;
